function getDeviceType() {
  if (typeof window === "undefined") return "desktop";
  const width = window.innerWidth;
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}
function getPageNameFromPath(pathname) {
  if (pathname === "/" || pathname === "") return "Homepage";
  if (pathname.includes("/pdp/") || pathname.includes("/p/")) return "Product Detail Page";
  if (pathname.includes("/brand/")) return "Brand Page";
  if (pathname.includes("/search")) return "Search Results";
  if (pathname.includes("/category/")) return "Category Page";
  if (pathname.includes("/brandclub")) return "Brandclub Page";
  return "Other";
}
function getPageTypeFromPath(pathname) {
  if (pathname === "/" || pathname === "") return "homepage";
  if (pathname.includes("/pdp/") || pathname.includes("/p/")) return "pdp";
  if (pathname.includes("/brand/")) return "brand";
  if (pathname.includes("/search")) return "search";
  if (pathname.includes("/category/")) return "category";
  if (pathname.includes("/brandclub")) return "brandclub";
  return "other";
}
function getUTMParams() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  return {
    utmSource: params.get("utm_source") || void 0,
    utmMedium: params.get("utm_medium") || void 0,
    utmCampaign: params.get("utm_campaign") || void 0
  };
}
function truncateQuery(query, maxLength = 200) {
  if (query.length <= maxLength) return query;
  return query.substring(0, maxLength) + "...";
}
export {
  getDeviceType,
  getPageNameFromPath,
  getPageTypeFromPath,
  getUTMParams,
  truncateQuery
};
//# sourceMappingURL=ConciergeTrackingTypes.js.map
